import getRuntimeEnvs from "@workspace/nextjs_utils/src/getRuntimeEnvs";

const getEnv = (name: string, defaultValue?: string) =>
  getRuntimeEnvs()?.[name] ?? process.env[name] ?? defaultValue;

export default getEnv;
